import React from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';

const useStyle = makeStyles(({ colors }: Theme) => createStyles({
  title: {
    fontSize: '16px',
    fontWeight: 500,
    color: colors.unselected,
    borderBottom: `1px solid ${colors.outlines}`,
    fontFamily: 'Montserrat',
    letterSpacing: '0.5px',
    margin: 0,
  },
}), { name: 'SectionTitle' });

type SectionTitleProps = {
  children: React.ReactNode;
};

const SectionTitle = ({ children }: SectionTitleProps) => {
  const classes = useStyle();

  return (
    <h3 className={classes.title}>
      {children}
    </h3>
  );
};

export default SectionTitle;
